import React, { useState } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import PropTypes from "prop-types";
import { BowlineIcon } from "@bkry/bowline-components/Icon";

const BowlineConnectButton = ({ setShowBowlineConnectInfo }, context) => {
  // const { suggestedChainId } = props;
  const handleConnect = () => {
    setShowBowlineConnectInfo(true);
  };
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseEnter = () => {
    setIsHovering(!isHovering);
  };
  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <>
      <Card
        id="bc-connect-button"
        style={{ cursor: "pointer" }}
        className={`shadow-sm mr-5 wallet-btn-wrapper my-3 ${
          isHovering ? "bg-primary text-white" : ""
        }`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleConnect}
      >
        <CardBody className="d-flex align-items-center mobile-display">
          <BowlineIcon />
          <div className="mt-2">
            <CardTitle className="h4 fw-bold mb-1">
              {"Social Connect"}{" "}
            </CardTitle>
            {/* <p>{context.t("Connect to your Wallet via Social Connect.")}</p> */}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

/**  define proptype for the 'translation' function  */
BowlineConnectButton.contextTypes = {
  t: PropTypes.func,
};

BowlineConnectButton.propTypes = {
  setShowBowlineConnectInfo: PropTypes.func,
};

BowlineConnectButton.defaultProps = {};

export default BowlineConnectButton;
